/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TimeInputs */

const en_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const es_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora`)
};

const fr_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure`)
};

const de_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit`)
};

const id_time = /** @type {(inputs: TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu`)
};

/** @type {(inputs: TimeInputs) => LocalizedString} */
const ja_time = en_time;

/** @type {(inputs: TimeInputs) => LocalizedString} */
const zh_time = en_time;

/** @type {(inputs: TimeInputs) => LocalizedString} */
const ar_time = en_time;

/** @type {(inputs: TimeInputs) => LocalizedString} */
const it_time = en_time;

/** @type {(inputs: TimeInputs) => LocalizedString} */
const ru_time = en_time;

/** @type {(inputs: TimeInputs) => LocalizedString} */
const pt_time = en_time;

/** @type {(inputs: TimeInputs) => LocalizedString} */
const ko_time = en_time;

/**
* | output |
* | --- |
* | "Time" |
*
* @param {TimeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const time = /** @type {((inputs?: TimeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TimeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_time(inputs)
	if (locale === "es") return es_time(inputs)
	if (locale === "fr") return fr_time(inputs)
	if (locale === "de") return de_time(inputs)
	if (locale === "ja") return ja_time(inputs)
	if (locale === "zh") return zh_time(inputs)
	if (locale === "ar") return ar_time(inputs)
	if (locale === "id") return id_time(inputs)
	if (locale === "it") return it_time(inputs)
	if (locale === "ru") return ru_time(inputs)
	if (locale === "pt") return pt_time(inputs)
	return ko_time(inputs)
});